<div ngbDropdown placement="bottom-end" class="d-inline-block">
  <button
    type="button"
    ngbDropdownToggle
    data-bs-toggle="dropdown"
    class="btn btn-system no-arrow"
    [attr.aria-label]="i18n.tr('open')"
    (click)="notifications.load()"
  >
    <span class="badge badge-icon pos-top pos-end">{{ totalCount() }}</span>
    <svg class="sa-icon sa-icon-2x" aria-hidden="true">
      <use href="/assets/icons/sprite.svg#bell"></use>
    </svg>
  </button>
  <div
    ngbDropdownMenu
    class="dropdown-menu-animated dropdown-xl dropdown-menu-end p-0 notification-menu"
  >
    <div class="notification-header rounded-top mb-2">
      <h4 class="m-0">
        {{ i18n.tr("title")
        }}<small class="mb-0 opacity-80"
          >{{ notifications.unreadCount() }} {{ i18n.tr("unread") }}</small
        >
      </h4>
    </div>
    @if (jobActiveCount() > 0) {
      <section class="job-section" aria-labelledby="notification-jobs-heading">
        <div class="px-3 py-2">
          <h6 id="notification-jobs-heading" class="mb-1">
            {{ tr("common.jobTracking.dropdownTitle") }}
          </h6>
          <small class="text-muted">{{
            tr("common.jobTracking.activeJobsWithProgress", {
              count: jobActiveCount(),
              progress: jobProgressAverage(),
            })
          }}</small>
        </div>
        <ul class="notification job-notification-list">
          @for (job of jobActiveJobs(); track job.jobId) {
            <li class="alert">
              <div>
                <div
                  class="d-flex justify-content-between align-items-start gap-3"
                >
                  <span class="d-flex flex-column flex-1 min-w-0">
                    <span class="name text-truncate">
                      {{ jobTypeLabel(job.jobType) }}
                    </span>
                    @if (job.stepName) {
                      <span class="msg-a fs-sm text-muted text-truncate">
                        {{ job.stepName }}
                      </span>
                    }
                  </span>
                  <span class="badge text-bg-light border flex-shrink-0">
                    {{ jobStatusLabel(job.status) }}
                  </span>
                </div>

                <div class="d-flex align-items-center gap-2 mt-2">
                  <div
                    class="progress progress-sm flex-grow-1"
                    role="progressbar"
                    [attr.aria-label]="jobTypeLabel(job.jobType)"
                    [attr.aria-valuenow]="job.progressPercent"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      class="progress-bar"
                      [style.width.%]="job.progressPercent"
                    ></div>
                  </div>
                  <span class="fs-sm text-muted"
                    >{{ job.progressPercent }}%</span
                  >
                </div>
              </div>
            </li>
          }
        </ul>
      </section>
      <div class="dropdown-divider m-0"></div>
      <h6 class="px-3 pt-3 mb-0">{{ i18n.tr("title") }}</h6>
    }
    @if (notifications.failed()) {
      <p class="p-3 mb-0 text-muted">{{ i18n.tr("loadFailed") }}</p>
    }
    <ul class="list-unstyled mb-0">
      @for (item of notifications.notifications(); track item.id) {
        <li
          class="p-3 border-bottom d-flex align-items-start gap-3"
          [class.bg-body-tertiary]="item.status === 'unread'"
        >
          <div class="flex-grow-1">
            <span class="d-block fw-semibold">{{
              item.type === "ai-evaluation-quota"
                ? i18n.tr("quotaTitle")
                : item.title
            }}</span
            ><span class="d-block fs-sm mt-1">{{
              item.type === "ai-evaluation-quota"
                ? i18n.tr("quotaMessage")
                : item.message
            }}</span>
            @if (item.status === "unread") {
              <button
                type="button"
                class="btn btn-link btn-sm px-0"
                (click)="notifications.markRead(item.id)"
              >
                {{ i18n.tr("markRead") }}
              </button>
            }
          </div>
          <button
            type="button"
            class="btn-close"
            [attr.aria-label]="i18n.tr('dismiss')"
            (click)="notifications.dismiss(item.id)"
          ></button>
        </li>
      } @empty {
        <li class="p-3 text-muted">{{ i18n.tr("empty") }}</li>
      }
    </ul>
  </div>
</div>
